// Zahlungsabgleich, Zuordnen von Hand: laufende Summe der angehakten Rechnungen gegen den
// Zahlungsbetrag, Suche in den uebrigen offenen Rechnungen. Die stehen einmal fuer die ganze Seite
// in #bank-open-invoices (JSON) und werden erst bei einer Suche als Haken eingeblendet.
const BANK_ASSIGN_MAX_HITS = 20

function bankAssignInvoices() {
  const source = document.getElementById('bank-open-invoices')
  if (!source) return []
  if (!source.parsed) source.parsed = JSON.parse(source.textContent)
  return source.parsed
}

function bankAssignUpdate(form) {
  const amount = parseInt(form.dataset.amount, 10)
  const picked = form.querySelectorAll('.bank-assign-pick:checked')
  const sum = Array.from(picked).reduce((total, box) => total + parseInt(box.dataset.cents, 10), 0)
  const label = form.querySelector('.bank-assign-sum')
  const submit = form.querySelector('.bank-assign-submit')
  if (!label) return

  const euro = (cents) => (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
  const difference = amount - sum
  let text = `${label.dataset.label} ${euro(sum)} / ${euro(amount)}`
  if (picked.length > 0) {
    text += difference === 0 ? ` – ${label.dataset.match}` : ` – ${label.dataset.difference} ${euro(difference)}`
  }
  label.textContent = text
  label.classList.toggle('text-success', picked.length > 0 && difference === 0)
  if (submit) submit.disabled = picked.length === 0
}

// Ein Haken fuer eine gefundene Rechnung - nur ueber textContent, der Kundenname ist fremder Text
function bankAssignHit(form, invoice) {
  const id = `pick-${form.dataset.transaction}-${invoice.id}`
  const row = document.createElement('div')
  row.className = 'form-check'
  const box = document.createElement('input')
  box.type = 'checkbox'
  box.className = 'form-check-input bank-assign-pick'
  box.name = 'invoice_ids[]'
  box.value = invoice.id
  box.id = id
  box.dataset.cents = invoice.cents
  const label = document.createElement('label')
  label.className = 'form-check-label'
  label.htmlFor = id
  const number = document.createElement('strong')
  number.textContent = invoice.number
  label.append(number, ` · ${invoice.account} · ${invoice.label}`)
  row.append(box, label)
  return row
}

function bankAssignSearch(form, query) {
  const other = form.querySelector('.bank-assign-other')
  const hits = form.querySelector('.bank-assign-hits')
  const more = form.querySelector('.bank-assign-more')
  if (!other || !hits) return

  // angehakte Treffer bleiben stehen, auch wenn die Suche sich aendert
  const kept = Array.from(hits.querySelectorAll('.bank-assign-pick:checked')).map((box) => box.closest('.form-check'))
  const keptIds = kept.map((row) => row.querySelector('.bank-assign-pick').value)
  const fixed = JSON.parse(form.dataset.fixed || '[]').map(String)
  const words = query.trim().toLowerCase().split(/\s+/).filter((word) => word.length > 0)
  const found = words.length === 0 ? [] : bankAssignInvoices().filter((invoice) =>
    !fixed.includes(String(invoice.id)) && !keptIds.includes(String(invoice.id)) &&
    words.every((word) => invoice.search.includes(word)))

  hits.replaceChildren(...kept, ...found.slice(0, BANK_ASSIGN_MAX_HITS).map((invoice) => bankAssignHit(form, invoice)))
  if (more) more.classList.toggle('d-none', found.length <= BANK_ASSIGN_MAX_HITS)
  other.classList.toggle('d-none', hits.children.length === 0)
}

function bankAssignInit() {
  document.querySelectorAll('form.bank-assign').forEach((form) => bankAssignUpdate(form))
}

document.addEventListener('turbo:load', bankAssignInit)
document.addEventListener('DOMContentLoaded', bankAssignInit)

document.addEventListener('change', (event) => {
  if (!event.target.classList.contains('bank-assign-pick')) return
  bankAssignUpdate(event.target.closest('form.bank-assign'))
})

document.addEventListener('input', (event) => {
  if (!event.target.classList.contains('bank-assign-search')) return
  bankAssignSearch(event.target.closest('form.bank-assign'), event.target.value)
})

// Enter im Suchfeld sucht, es bucht nicht
document.addEventListener('keydown', (event) => {
  if (event.key === 'Enter' && event.target.classList.contains('bank-assign-search')) event.preventDefault()
})
